var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9785 21.7422C11.4994 21.7422 6.82031 22.5706 6.82031 25.8883C6.82031 29.206 11.4697 30.0641 16.9785 30.0641C22.4576 30.0641 27.1353 29.2343 27.1353 25.918C27.1353 22.6016 22.4873 21.7422 16.9785 21.7422Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9786 17.0095C20.5742 17.0095 23.4885 14.0938 23.4885 10.4982C23.4885 6.90257 20.5742 3.98828 16.9786 3.98828C13.383 3.98828 10.4673 6.90257 10.4673 10.4982C10.4552 14.0817 13.3506 16.9973 16.9327 17.0095H16.9786Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.c8cda7ef0e0847a54575cf9e32622fb5.svg";
export { ForwardRef as ReactComponent };